<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
        v-if="showAddContract"
        class="bg-black fixed h-screen bg-opacity-70 inset-0 z-50 w-full"
      >
        <form
          @submit.prevent="createContract"
          class="fixed center-h-v bg-white rounded-md shadow-2xl sm:w-1/2 w-full overflow-y-auto h-auto"
        >
          <transition name="fade">
            <div
              v-if="loading"
              class="inset-0 absolute bg-black rounded-md bg-opacity-50 w-full"
            >
              <loader class="center-h-v" />
            </div>
          </transition>
          <div class="flex justify-between items-center border-b-1.5 p-3">
            <p class="text-base">Add Employee Contract</p>
            <img
              class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png"
              @click="close()"
            />
          </div>
          <transition name="fade">
            <div
              v-if="createContractError"
              class="p-1 text-center text-sm w-full bg-yellow-200"
            >
              {{ createContractError }}
            </div>
          </transition>

          <!-- Contract Information -->
          <div class="p-2">
            <div
              class="grid grid-cols-1 sm:lg:grid-cols-2 lg:grid-cols-3 gap-5"
            >
              <div class="text-sm">
                <label class="block pb-1">Type</label>

                <!-- Use el-select to display employment types -->
                <select
                  v-model="contractInfo.EmployementTypeId"
                  placeholder="Select Type"
                  filterable
                  class="w-full bg-gray-200"
                >
                  <option
                    v-for="employmentType in employmentTypes"
                    :key="employmentType.Id"
                    :label="employmentType.Name"
                    :value="employmentType.Id"
                  >
                    {{ employmentType.Name }}
                  </option>
                </select>
              </div>

              <div class="text-sm">
                <label class="block pb-1">Job Title</label>

                <!-- Use el-select to display job titles -->
                <select
                  v-model="contractInfo.JobTitleId"
                  placeholder="Select Job Title"
                  filterable
                  class="w-full bg-gray-200"
                >
                  <option
                    v-for="jobTitle in jobTitles"
                    :key="jobTitle.Id"
                    :label="jobTitle.Name"
                    :value="jobTitle.Id"
                  >
                    {{ jobTitle.Name }}
                  </option>
                </select>
              </div>

              <div class="text-sm">
                <label class="block pb-1">Start Date</label>
                <input
                  v-model="contractInfo.StartDate"
                  type="date"
                  class="w-full bg-gray-200"
                  placeholder="Select Start Date"
                  style="width: 100%"
                />
              </div>

              <div class="text-sm">
                <label class="block pb-1">End Date</label>
                <input
                  v-model="contractInfo.EndDate"
                  type="date"
                  class="w-full bg-gray-200"
                  placeholder="Select End Date"
                  style="width: 100%"
                />
              </div>

              <div class="text-sm">
                <label class="block pb-1">Status</label>
                <!-- {{ employmentStatus }} -->
                <!-- Use el-select to display job status -->
                <select
                  v-model="contractInfo.EmployementStatusId"
                  placeholder="Select Job Title"
                  filterable
                  class="w-full bg-gray-200"
                >
                  <option
                    v-for="statu in employmentStatus"
                    :key="statu.Id"
                    :label="statu.Name"
                    :value="statu.employmentStatusId"
                  >
                    {{ statu.Name }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <!-- Action section -->
          <div class="flex justify-end p-5">
            <button
              type="submit"
              class="bg-primary rounded-full px-10 text-sm text-white py-2"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from 'axios';
import Loader from '@/components/loader/loader.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'AddContract',
  props: ['showAddContract', 'activeTab', 'reload'],
  components: { Loader },
  data() {
    return {
      loading: false,
      createContractError: null,
      contractInfo: {
        EmployeeId: '',
        EmployementTypeId: '',
        JobTitleId: '',
        EmployementStatusId: '',
        StartDate: '',
        EndDate: null,
      },
      employmentTypes: [],
      jobTitles: [],
      employmentStatus: [],
    };
  },
  computed: {
    ...mapGetters(['getOrganization', 'getToken', 'getCurrentEmployeeId']),
  },
  created() {
    // Fetch employment types and job titles when the component is created
    this.fetchEmploymentTypes();
    this.fetchJobTitles();
    this.fetchEmploymentStatus();
  },
  methods: {
    close() {
      this.$emit('close');
    },
    // /{organization}/employee/contract/v1/create
    createContract() {
      this.loading = true;
      this.contractInfo.EmployeeId = this.getCurrentEmployeeId;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          'Content-Type': 'application/json',
        },
      };

      axios
        .post(
          `${this.getOrganization}/employee/contract/${this.$ApiVersion}/create`,
          JSON.stringify(this.contractInfo),
          options
        )
        .then(
          (response) => {
            this.loading = false;

            if (response.data.StatusCode == 200) {
              this.close();
              this.reload();
              (this.contractInfo = {
                EmployeeId: '',
                EmployementTypeId: '',
                JobTitleId: '',
                EmployementStatusId: '',
                StartDate: '',
                EndDate: '',
              }),
                this.$notify({
                  title: 'Success',
                  message: response.data.StatusMessage,
                  type: 'success',
                });
            } else {
              this.createContractError = response.data.StatusMessage;
              this.$notify.error({
                title: 'Success',
                message: response.data.StatusMessage,
              });
            }
          },
          (error) => {
            this.loading = false;
            this.createContractError = error.message;
            this.$notify.error({ title: 'Success', message: error.message });
          }
        );
    },
    fetchEmploymentTypes() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          'Content-Type': 'application/json',
        },
      };
      axios
        .get(
          `${this.getOrganization}/setup/employementtype/${this.$ApiVersion}/request`,
          options
        )
        .then((response) => {
          if (response.data.StatusCode === 200) {
            this.employmentTypes = response.data.Data;
          } else {
            this.$notify.error({
              title: 'Error',
              message: 'Error fetching employment types',
            });
          }
        })
        .catch((error) => {
          console.error('Error fetching employment types:', error);
          this.$notify.error({
            title: 'Error',
            message: 'Error fetching employment types',
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    fetchJobTitles() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          'Content-Type': 'application/json',
        },
      };
      axios
        .get(
          `${this.getOrganization}/setup/jobtitle/${this.$ApiVersion}/request`,
          options
        )
        .then((response) => {
          if (response.data.StatusCode === 200) {
            this.jobTitles = response.data.Data;
          } else {
            this.$notify.error({
              title: 'Error',
              message: 'Error fetching job titles',
            });
          }
        })
        .catch((error) => {
          console.error('Error fetching job titles:', error);
          this.$notify.error({
            title: 'Error',
            message: 'Error fetching job titles',
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    fetchEmploymentStatus() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          'Content-Type': 'application/json',
        },
      };
      axios
        .get(
          `${this.getOrganization}/setup/employment/status/${this.$ApiVersion}/request`,
          options
        )
        .then((response) => {
          if (response.data.StatusCode === 200) {
            this.employmentStatus = response.data.Data;
          } else {
            this.$notify.error({
              title: 'Error',
              message: 'Error fetching employment status',
            });
          }
        })
        .catch((error) => {
          console.error('Error fetching employment status:', error);
          this.$notify.error({
            title: 'Error',
            message: 'Error fetching employment status',
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
